import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password, "SUPER_ADMIN");
    setLoading(false);
    if (result.success) {
      navigate("/ali-admin-portal/dashboard");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-900">
      <header className="border-b border-slate-800 px-4 py-4 sm:px-6">
        <Link to="/" className="mx-auto flex max-w-6xl items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-teal-600 text-white">
            <Leaf className="h-5 w-5" />
          </div>
          <span className="text-lg font-semibold text-white">RootLyst</span>
          <span className="ml-2 rounded-full bg-slate-800 px-2.5 py-0.5 text-xs font-medium text-slate-400">
            Super Admin Portal
          </span>
        </Link>
      </header>
      <div className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-xl border border-slate-800 bg-slate-950 p-8 shadow-lg">
          <div className="mb-6">
            <h1 className="text-lg font-semibold text-white">Sign in to your account</h1>
            <p className="mt-1 text-sm text-slate-400">Manage clinics, doctors and subscriptions.</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email" className="text-slate-300">
                Email
              </Label>
              <Input
                data-testid="admin-login-email"
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 border-slate-700 bg-slate-900 text-white"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-300">
                Password
              </Label>
              <Input
                data-testid="admin-login-password"
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 border-slate-700 bg-slate-900 text-white"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="text-sm text-red-400">
                {error}
              </p>
            )}
            <Button
              data-testid="admin-login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-teal-600 hover:bg-teal-700"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
          <Link to="/" className="mt-6 flex items-center gap-1 text-xs text-slate-500 hover:text-slate-300">
            <Leaf className="h-3 w-3" /> Back to RootLyst
          </Link>
        </div>
      </div>
    </div>
  );
}
